// extracted by mini-css-extract-plugin
export default {"Cover":"Cover_Cover__NeV+i","Bottom":"Cover_Bottom__ITaqS"};